module.exports = __webpack_public_path__ + "img/seychelles.fc8b1936.svg";